import Vue from "vue";

class WebSocketService {
  constructor() {
    this.ws = null;
    this.url = "";
    this.reconnectTimer = null;
    this.reconnectCount = 0;
    this.maxReconnectCount = 10;
    this.heartbeatTimer = null;
    this.heartbeatInterval = 30000;
    this.vueInstance = new Vue(); // 关键：创建独立 Vue 实例用于事件分发
  }

  // 初始化连接
  connect(url) {
    if (this.ws && this.ws.readyState === WebSocket.OPEN) {
      console.log("WebSocket 已连接");
      return;
    }

    this.url = url;
    this.ws = new WebSocket(url);

    // 连接成功（修改：用独立 Vue 实例触发事件）
    this.ws.onopen = () => {
      console.log("WebSocket 连接成功");
      this.reconnectCount = 0;
      this.startHeartbeat();
      this.vueInstance.$emit("websocket:open"); // 关键修改
    };

    // 接收消息（修改：用独立 Vue 实例触发事件）
    this.ws.onmessage = (event) => {
      try {
        // const data = JSON.parse(event.data);
        this.vueInstance.$emit("websocket:message", event); // 关键修改
      } catch (err) {
        console.error("解析消息失败：", err);
        this.vueInstance.$emit("websocket:message", event); // 关键修改
      }
    };

    // 连接关闭（修改：用独立 Vue 实例触发事件）
    this.ws.onclose = (event) => {
      console.log("WebSocket 关闭：", event.code, event.reason);
      this.vueInstance.$emit("websocket:close", event); // 关键修改
      this.stopHeartbeat();
      this.reconnect();
    };

    // 连接错误（修改：用独立 Vue 实例触发事件）
    this.ws.onerror = (error) => {
      console.error("WebSocket 错误：", error);
      this.vueInstance.$emit("websocket:error", error); // 关键修改
      this.stopHeartbeat();
    };
  }

  send(data) {
    if (!this.ws || this.ws.readyState !== WebSocket.OPEN) {
      console.error("WebSocket 未连接，无法发送消息");
      return false;
    }
    try {
      // 发送 JSON 格式消息
      const sendData = JSON.stringify({ message: data });
      this.ws.send(sendData);
      return true;
    } catch (err) {
      console.error("发送消息失败：", err);
      return false;
    }
  }

  close(code = 1000, reason = "正常关闭") {
    if (this.ws) {
      this.ws.close(code, reason);
      this.ws = null;
      this.stopReconnect();
      this.stopHeartbeat();
    }
  }

  reconnect() {
    if (this.reconnectCount >= this.maxReconnectCount) {
      console.error(
        `已超过最大重连次数（${this.maxReconnectCount}次），停止重连`
      );
      return;
    }
    this.stopReconnect();
    const delay = Math.min(1000 * this.reconnectCount, 5000);
    this.reconnectTimer = setTimeout(() => {
      this.reconnectCount++;
      console.log(`第 ${this.reconnectCount} 次重连...`);
      this.connect(this.url);
    }, delay);
  }

  stopReconnect() {
    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer);
      this.reconnectTimer = null;
    }
  }

  startHeartbeat() {
    this.stopHeartbeat();
    this.heartbeatTimer = setInterval(() => {
      this.send({ type: "heartbeat", time: Date.now() });
    }, this.heartbeatInterval);
  }

  stopHeartbeat() {
    if (this.heartbeatTimer) {
      clearInterval(this.heartbeatTimer);
      this.heartbeatTimer = null;
    }
  }
}

// 实例化并挂载到 Vue 原型
const websocketService = new WebSocketService();
Vue.prototype.$websocket = websocketService;

export default websocketService;



// WEBPACK FOOTER //
// ./src/utils/websocket.js